import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkMenuModule } from '@angular/cdk/menu';
import { FcpButtonModule } from '../fcp-button';
import { FcpButtonSplitComponent } from './fcp-button-split.component';
import { FcpIconModule } from '../fcp-icon';

@NgModule({
    declarations: [FcpButtonSplitComponent],
    exports: [FcpButtonSplitComponent],
    imports: [CommonModule, CdkMenuModule, FcpButtonModule, FcpIconModule]
})
export class FcpButtonSplitModule {}
